import { render, staticRenderFns } from "./CargaOts.vue?vue&type=template&id=d75fee7e&scoped=true&"
import script from "./CargaOts.vue?vue&type=script&lang=js&"
export * from "./CargaOts.vue?vue&type=script&lang=js&"
import style0 from "./CargaOts.vue?vue&type=style&index=0&id=d75fee7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75fee7e",
  null
  
)

export default component.exports